class ConvenioIcmsController extends AbstractController
  @$inject = [ '$injector', '$scope', 'pathService', 'estadoService', 'convenioIcmsService' ]

  constructor: ($injector, @scope, pathService, @estadoService, @convenioIcmsService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/convenio/"
    @loadingTracker = @promiseTracker()
    @modalConvenio = @openPopup(@url + "modal.html", 'convenioIcmsModalController as ctrl')
    
    @filtro =
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfConvenio = []
    @listOfEstado = []

    @loadingTracker.addPromise @estadoService.getList((data) =>
      @listOfEstado = data
    )

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @convenioIcmsService.getList(filtro,(result) =>
      if result.success
        @listOfConvenio = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de convênios.', 'Erro!', false)
    )


  add: ->
    @modalConvenio({
      convenio: => {
        estado: @filtro.estado
      }
      listOfEstado: =>  @listOfEstado
    }, (result) =>
      @loadData())

  edit: (convenio) ->
    @modalConvenio({
      convenio: => angular.copy(convenio)
      listOfEstado: =>  @listOfEstado
    }, (result) =>
      @loadData())


  remover: (convenio)->
    Confirm.warning('Atenção', "Deseja realmente remover o convênio ##{convenio.id} - #{convenio.descricao}?", {
      Sim: =>
        @convenioIcmsService.delete(convenio.id, (result)=>
          if(result.success)
            Alert.success("O convênio ##{convenio.id} - #{convenio.descricao} foi removido!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover o convênio ##{convenio.id} - #{convenio.descricao}.")
        )
      Não: ''
    })

angular.module('eficienciaFiscalModule').controller('convenioIcmsController', ConvenioIcmsController)

class ConvenioIcmsModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'convenioIcmsService', 'convenio', 'listOfEstado' ]

  constructor: ($injector, @modalInstance, @convenioIcmsService, @convenio, @listOfEstado) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @observacao = ''
    @convenio.observacoes ?= []

  addObservacao: ->
    @convenio.observacoes.push {texto: @observacao}
    @observacao = ''

  removerObservacao: (index)->
    if(index > -1)
      @convenio.observacoes.splice(index, 1)

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @convenioIcmsService.save(@convenio, (data) =>
        Alert.success("Convênio <strong>#{data.descricao} - #{data.convenio}</strong> #{if @convenio.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('convenioIcmsModalController', ConvenioIcmsModalController)